import StoreFilterContainer from "../components/StoreFilterContainer";

/**
 * React component for the Tire Store filter page.
 * Renders the StoreFilterContainer with type set to "tire".
 */
export default function MstTireWheelStore() {
  return <StoreFilterContainer type="tire" />;
}
